module.exports = __webpack_public_path__ + "images/corners/Round.375d37da3ceba3760ec57656edcef16e.jpg";